/*
 * Toggles the post-purchase free-gift notice (Hyaluronserum Soaring Stream) shown in the
 * cart / drawer when a qualifying gift code (NKP30 / NKP20) is applied.
 *
 * Loaded as an external, deferred script from the theme layouts (like theme.js) so it keeps
 * working across the theme's instant navigation and AJAX cart re-renders.
 *
 * A code can reach the cart two ways:
 *   1. /discount/CODE links  -> sets the `discount_code` cookie
 *   2. the discount field     -> POST /cart/update.js (does NOT set that cookie)
 * so we detect the active gift code from the cart's applied discount codes (authoritative
 * for both paths), with the cookie as a fast fallback. The result toggles the
 * `free-gift-active` class on <html>, which the notice's CSS keys off.
 */
(function () {
  if (window.__freeGiftNoticeInit) return;
  window.__freeGiftNoticeInit = true;

  var GIFT_CODES = ['NKP30', 'NKP20'];

  function setActive(on) {
    document.documentElement.classList.toggle('free-gift-active', !!on);
  }

  function cartHasGiftCode(cart) {
    if (!cart || !cart.discount_codes) return false;
    return cart.discount_codes.some(function (entry) {
      return entry.applicable && GIFT_CODES.indexOf((entry.code || '').toUpperCase()) !== -1;
    });
  }

  function cookieHasGiftCode() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    var code = match ? decodeURIComponent(match[1]).toUpperCase() : '';
    return GIFT_CODES.indexOf(code) !== -1;
  }

  function check(event) {
    // Prefer cart data carried on the cart:refresh / cart:updated event (no extra request).
    if (event && event.detail && event.detail.cart && event.detail.cart.discount_codes) {
      setActive(cartHasGiftCode(event.detail.cart));
      return;
    }

    // Cookie fast-path (covers /discount/ links).
    if (cookieHasGiftCode()) {
      setActive(true);
      return;
    }

    // Otherwise ask the cart — covers codes applied via /cart/update.js (no cookie).
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setActive(cartHasGiftCode(cart)); })
      .catch(function () {});
  }

  check();
  document.addEventListener('cart:updated', check);
  document.addEventListener('cart:refresh', check);
  window.addEventListener('pageshow', check);
})();
